import $ from 'jquery'
import nowAndLater from '@digicomp/now-and-later'
import initIcons from './fontawesome';
import initializeModalStack from "@digicomp/modal-stack";
import {Modal} from 'bootstrap';

const {initializeModalOpener} = initializeModalStack({modalImpl: Modal});
initIcons();

// current bootstrap modals need jQuery on window to initialize jQuery event handling and plugins
window.jQuery = $;

nowAndLater('.dataTable', target => {
    import(/* webpackChunkName: "datatables" */'./datatables')
        .then(async ({init: initTable}) => {
            await initTable(target);
        });
});

nowAndLater('.addStampButton', target => {
    import('@digicomp/form-stamp')
        .then(({formStamp}) => {
            formStamp(target);
        });
});

nowAndLater('[data-provide=datepicker]', target => {
    import('bootstrap-datepicker');
});

nowAndLater('[data-ajax-modal-uri]', target => {
    initializeModalOpener(target);
});

nowAndLater('select.select2', target => {
    let dropdownParent = $(document.body);
    let $modalContent = $(target).parents('.modal-content');
    if ($modalContent.length !== 0) {
        dropdownParent = $modalContent;
    }

    import('select2/dist/js/select2.full').then(() => {
        const options = {
            theme: "bootstrap-5",
            dropdownParent: dropdownParent,
            placeholder: target.ariaPlaceholder,
            containerCssClass() {
                if (target.classList.contains('is-invalid')) {
                    return 'is-invalid';
                }
                return '';
            },
        };
        if (target.dataset.optionsUri) {
            options.ajax = {
                url: target.dataset.optionsUri,
                dataType: 'json'
            };
        }
        $(target).select2(options);
    });
});

nowAndLater('.f3-form-error', (target) => {
    target.classList.add('is-invalid');
});
